import { ApiService } from 'services';
import { toastr } from 'react-redux-toastr';

import { handleException } from 'actions/exceptions';
import React from 'react';
import { PropTypes } from 'prop-types';

export const EDIT_CUSTOMER = 'EDIT_CUSTOMER';
export const EDIT_CUSTOMER_CANCEL = 'EDIT_CUSTOMER_CANCEL';
export const UPDATE_CUSTOMER_REQUEST = 'UPDATE_CUSTOMER_REQUEST';
export const UPDATE_CUSTOMER_SUCCESS = 'UPDATE_CUSTOMER_SUCCESS';
export const UPDATE_CUSTOMER_ERROR = 'UPDATE_CUSTOMER_ERROR';

function edit() {
  return {
    type: EDIT_CUSTOMER
  };
}

function cancelEdit() {
  return {
    type: EDIT_CUSTOMER_CANCEL
  };
}

function request() {
  return {
    type: UPDATE_CUSTOMER_REQUEST
  };
}

function receive() {
  return {
    type: UPDATE_CUSTOMER_SUCCESS,
  };
}

function reject() {
  return {
    type: UPDATE_CUSTOMER_ERROR
  };
}

export function editCustomer() {
  return (dispatch) => {
    dispatch(edit());
  };
}

export function cancelEditCustomer() {
  return (dispatch) => {
    dispatch(cancelEdit());
  };
}

const MemoizedErrorToastr = errorList => React.useCallback(<ErrorToastr errorList={ errorList } />, [errorList]);

const ErrorToastr = ({ errorList }) => (
  <div className="customer-account-form-confirm">
    <h1>Missing/incorrect data</h1>
    <hr />
    <p>
      {/* eslint-disable-next-line react/destructuring-assignment */}
      {errorList && errorList.map(error => <li key={ error }>{error}</li>)}
    </p></div>);

ErrorToastr.propTypes = {
  errorList: PropTypes.arrayOf(PropTypes.string)
};

ErrorToastr.defaultProps = {
  errorList: []
};

function openUpdateErrorsToast(errorList) {
  const toastOptions = {
    disableCancel: true,
    component: () => MemoizedErrorToastr(errorList)

  };

  toastr.confirm(null, toastOptions);
}

export function updateCustomer(customerData, dispatch) {
  const customerId = customerData?.customer?.customerId;

  dispatch(request());
  const promise = () => ApiService
    .updateCustomer(customerId, customerData)
    .then((response) => {
      dispatch(receive());
      toastr.success('Success', 'Shareholder updated successfully');
    })
    .catch((error) => {
      if (!error.response && error.retries && error.retries > 1) {
        ApiService.addQueuedPromise(promise, error);
      }
      if (error.response || (error.retries && error.retries > 1)) {
        const errorList = (error?.response?.data.error?.message?.split(/\r?\n/)?.filter(err => err.trim() !== '')) ?? null;

        switch (error?.response?.data?.error?.code) {
          case 170:
          case 1010:

            if (errorList && errorList.length > 0) {
              openUpdateErrorsToast(errorList);
            } else {
              dispatch(handleException(error, reject, true));
            }

            break;
          default:
            dispatch(handleException(error, reject, true));
        }

        dispatch(reject);
      }
    });
  return promise();
}
